import { render, staticRenderFns } from "./NewAuthorization.vue?vue&type=template&id=59987206&scoped=true&"
import script from "./NewAuthorization.vue?vue&type=script&lang=js&"
export * from "./NewAuthorization.vue?vue&type=script&lang=js&"
import style0 from "./NewAuthorization.vue?vue&type=style&index=0&id=59987206&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59987206",
  null
  
)

export default component.exports